export enum BehaviorCodeNotificationsTableColumns {
  NAME = 'Name',
  DESCRIPTION = 'Description',
  TRIGGER_AT = 'Assigned At',
  ACTIONS = 'Actions'
}
